<template>
  <div>
    <bm-control v-bind="$attrs">
      <v-row align="center">
        <v-col>
          <div class="scan-waiting-box">
            <template v-if="!isScanning">
              {{ $m.scanner_mode_placeholder }}
            </template>
            <template v-else>
              {{ $m.scanned_barcode_processing }}
            </template>
          </div>
        </v-col>
        <v-col :cols="2">
          <slot name="append-outer" />
        </v-col>
      </v-row>
    </bm-control>
    <slot name="action" />
  </div>
</template>

<script setup lang="ts">
import BmControl from "@/components/controls/input/BmControl.vue";
import { onBeforeUnmount, onMounted, ref } from "vue";

/**
 * @desc An input that has no visible output but listens to events and fires an event on enter press
 */

interface Events {
  (event: "scan-complete", value: string): void;
}

const emit = defineEmits<Events>();

let inputBuffer = "";
const isScanning = ref(false);

const keydown = (event: KeyboardEvent) => {
  if (event.key === "Enter") {
    emit("scan-complete", inputBuffer);
    inputBuffer = "";
    setIsScanning(false);
  } else if (event.key && event.key.length === 1) {
    appendToInputBuffer(event.key);
  }
};

const appendToInputBuffer = (char: string | null) => {
  inputBuffer += char ?? "";
  setIsScanning(inputBuffer.length > 0);
};

const setIsScanning = (setScanning: boolean) => {
  isScanning.value = setScanning;
};

onMounted(() => {
  window.addEventListener("keydown", keydown);
});

onBeforeUnmount(() => {
  window.removeEventListener("keydown", keydown);
});
</script>

<style lang="sass">
.scan-waiting-box
  padding: 5px
  border: 2px dashed darkgrey
</style>
